import { IGGSTextFieldBehaviour } from './../../../../textfield/textfield/behaviour/IGGSTextFieldBehaviour';
/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 21.01.13, 15:48
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { BasicLayoutManager } from "../../BasicLayoutManager";

export class BasicGGSTextFieldMouseOverBehaviour implements IGGSTextFieldBehaviour {
    public execute(object: any = null): void {
        if( BasicLayoutManager.getInstance().customCursor ) {
            BasicLayoutManager.getInstance().customCursor.hideCustomCursor();
            if (BasicLayoutManager.getInstance().customCursor != null) {
                BasicLayoutManager.getInstance().customCursor.isEnabled = false;
            }
        }
    }
}

